import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ArrowLeft, ArrowRight } from 'lucide-react';
interface Option {
  id: string;
  label: string;
  description: string;
  icon?: React.ReactNode;
}
interface WizardStepProps {
  title: string;
  description: string;
  options: Option[];
  currentValue: string;
  onSelect: (id: string) => void;
  onNext: () => void;
  onBack?: () => void;
  isFirst?: boolean;
  isLast?: boolean;
}
export function WizardStep({
  title,
  description,
  options,
  currentValue,
  onSelect,
  onNext,
  onBack,
  isFirst,
  isLast
}: WizardStepProps) {
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {options.map((option) => (
          <button
            key={option.id}
            onClick={() => onSelect(option.id)}
            className={cn(
              "text-left p-4 rounded-md border transition-colors",
              currentValue === option.id
                ? "border-primary bg-primary/5 ring-1 ring-primary"
                : "bg-background border-border hover:bg-muted"
            )}
          >
            <div className="flex items-start gap-3">
              {option.icon && <div className="mt-0.5 text-muted-foreground">{option.icon}</div>}
              <div className="space-y-0.5">
                <div className="text-sm font-bold">{option.label}</div>
                <div className="text-xs text-muted-foreground">{option.description}</div>
              </div>
            </div>
          </button>
        ))}
      </div>
      <div className="flex justify-between items-center pt-6 border-t">
        <Button
          variant="outline"
          size="sm"
          onClick={onBack}
          disabled={isFirst}
          className={cn(isFirst && "invisible")}
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Previous
        </Button>
        <Button
          onClick={onNext}
          size="sm"
          disabled={!currentValue}
          className="bg-primary hover:bg-primary/90"
        >
          {isLast ? "Calculate" : "Continue"} <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}